import { render } from "./BuyNft.vue?vue&type=template&id=9daf8a16"
import script from "./BuyNft.vue?vue&type=script&lang=ts"
export * from "./BuyNft.vue?vue&type=script&lang=ts"
script.render = render

export default script